import { makeStyles } from "tss-react/mui";
import ColourConstants from "helpers/colourConstants";

export const INDENT_PER_LEVEL = 24;
export const BASE_INDENT = 24;

const useGroupedTableStyles = makeStyles()((theme) => ({
	tableHeadRow: {
		borderBottomColor: ColourConstants.tableBorder,
		borderBottomStyle: "solid",
		borderBottomWidth: 1,
		backgroundColor: ColourConstants.tableBackground,
		fontWeight: "bold",
		fontFamily: "Roboto Condensed",
		fontSize: 14,
	},
	selectedTableHeadRow: {
		borderBottomColor: ColourConstants.tableBorder,
		borderBottomStyle: "solid",
		borderBottomWidth: 1,
		backgroundColor: ColourConstants.tableBackgroundSelected,
		fontWeight: "bold",
		color: "#FFFFFF",
		fontFamily: "Roboto Condensed",
		fontSize: 14,
	},
	nameRow: {
		width: "20%",
	},
	actionColumn: {
		width: "10%",
		minWidth: "100px",
	},
	expandIcon: {
		padding: 4,
		marginRight: 4,
	},
	expandIconPlaceholder: {
		display: "inline-block",
		width: 32,
		marginRight: 4,
	},
	expandCell: {
		display: "flex",
		alignItems: "center",
	},
	childRow: {
		backgroundColor: "#FAFAFA",
	},
	loadingRow: {
		backgroundColor: "#FAFAFA",
	},
}));

export default useGroupedTableStyles;
